<!--
  The contents of this file are subject to the license and copyright
  detailed in the LICENSE_ATMIRE and NOTICE_ATMIRE files at the root of the source
  tree and available online at

  https://www.atmire.com/software-license/
 -->
<ds-item-search-result-list-element-client [object]="object"
                                           [linkType]="linkType"></ds-item-search-result-list-element-client>
